/**
 * @file 申请试用页面
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_USER_APPLY_DATA, GET_CMSAPI_USERAPPLY, AUTH_PRIVACY_COMPANY_V2} from './ActionTypes';

export function fetchCmsapiIndexData(dispatch) {
    return rcAjax('GET', '/cmsapi/mobileUserApplyData', {}, {}, data => {
        dispatch({type: GET_USER_APPLY_DATA, data: data.data});
    });
}

export function fetchUserApply(dispatch, obj) {
    return rcAjax('POST', '/cmsapi/userApply', obj, {}, data => {
        dispatch({type: GET_CMSAPI_USERAPPLY, data: data.data});
    });
}

export function fetchCompanyV2(dispatch, obj) {
    return rcAjax('POST', '/xiapi/api/v1/privacy/authPrivacyCompanyV2', {}, obj, data => {
        dispatch({type: AUTH_PRIVACY_COMPANY_V2, data: data.data});
    });
}


// WEBPACK FOOTER //
// ./src/actions/applyAction.js